"use client"
import { PopupButton } from "@typeform/embed-react"
import { twMerge } from "tailwind-merge"
import { buttonBasicStyles } from "../buttons/Button"
import { PrimaryButtonProps, primaryButtonStyles } from "../buttons/PrimaryButton"

const EmbedButton: React.FC<PrimaryButtonProps & { id: string; triggerId?: string }> = ({
  id,
  children,
  className,
  triggerId,
}) => {
  return (
    <PopupButton
      id={id}
      className={twMerge(`${buttonBasicStyles} ${primaryButtonStyles}`, className)}
      noScrollbars
      autoResize
      buttonProps={{ id: triggerId }}
      disableScroll>
      {children}
    </PopupButton>
  )
}

export default EmbedButton
